import ProfileMap from "./ProfileMap";

export default ProfileMap;
